import React from "react";
import type { ActivityChange } from "../activity-types";
import { StageChangeChunk } from "./stage-change-chunk";
import { DefaultChangeChunk } from "./default-change-chunk";
import { CreationChunk } from "./creation-chunk";
import { DateChunk } from "./date-chunk";
import { AddressChunk } from "./address-chunk";
import { AssigneeChunk } from "./assignee-chunk";
import { TeamsChunk } from "./teams-chunk";
import { AgeChangeChunk } from "./age-change-chunk";
import { CustomFieldChunk } from "./custom-field-chunk";
import { NoteChunk } from "./note-chunk";
import { NoteReplyChunk } from "./note-reply-chunk";
import { TypeChangeChunk } from "./type-change-chunk";
import { NameChangeChunk } from "./name-change-chunk";
import { AttachmentsChunk } from "./attachments-chunk";
import { FieldPhotosChunk } from "./field-photos-chunk";
import { FormSubmissionChunk } from "./form-submission-chunk";

interface ActionChunkProps {
  change: ActivityChange;
}

const changeTypeComponents: Record<
  string,
  React.ComponentType<{ change: ActivityChange }>
> = {
  name: NameChangeChunk,
  stageId: StageChangeChunk,
  task: CreationChunk,
  created: CreationChunk,
  updated: CreationChunk,
  startDate: DateChunk,
  targetDate: DateChunk,
  age: AgeChangeChunk,
  address: AddressChunk,
  assignees: AssigneeChunk,
  teams: TeamsChunk,
  values: CustomFieldChunk,
  note: NoteChunk,
  noteReply: NoteReplyChunk,
  issueTypeId: TypeChangeChunk,
  attachments: AttachmentsChunk,
  fieldPhotos: FieldPhotosChunk,
  formSubmission: FormSubmissionChunk,
};

export function ActionChunk({ change }: ActionChunkProps) {
  const Component =
    changeTypeComponents[change.target.type] || DefaultChangeChunk;
  return <Component change={change} />;
}
